export default __webpack_public_path__ + "static/media/floral7.d1aeae75.png";